import { createSlice } from '@reduxjs/toolkit';

interface LayoutState {
  layoutOverlay: boolean;
  sidebarCollapsed: boolean;
}

const initialState: LayoutState = {
  layoutOverlay: true,
  sidebarCollapsed: false,
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    toggleOverlay: (state) => {
      state.layoutOverlay = !state.layoutOverlay;
    },
    setOverlay: (state, action) => {
      state.layoutOverlay = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebarCollapsed: (state, action) => {
      state.sidebarCollapsed = action.payload;
    },
  },
});

export const { toggleOverlay, setOverlay, toggleSidebar, setSidebarCollapsed } = layoutSlice.actions;
export default layoutSlice.reducer;
